import {GameMasterApi} from '@/api/backendService.js';

/**
 * GameMasterCycle Service
 *
 * Steps the world clock by hand. `auto_cycle_player` is off by default
 * (`settings.AUTO_CYCLE_ENABLED` on the backend), so during a debugging session
 * nothing advances the world unless a GM, a management command or a script asks
 * it to — this is the browser's door to that.
 *
 * A sealed fight is on the fight worker's clock, not this one, and stepping the
 * world does not step a fight.
 */
export class GameMasterCycleService {
    /**
     * Where the world clock stands, and whether anything is driving it.
     * @returns {Promise<{campaign_id: string, cycle: number, phase: string, auto_play_enabled: boolean}>}
     */
    async getCurrent() {
        const response = await GameMasterApi.gamemasterCyclesCurrentRetrieve();
        return response.data;
    }

    /**
     * Advance one phase — the smallest useful step, and the one a debugging
     * session wants most of the time.
     */
    async advancePhase() {
        return this.advance({phases: 1});
    }

    /** Advance a whole cycle, however many phases that takes. */
    async advanceCycle() {
        return this.advance({cycles: 1});
    }

    /**
     * @param {{phases?: number, cycles?: number, campaignId?: string}} options
     *   `phases` and `cycles` are mutually exclusive — the server refuses both.
     */
    async advance({phases, cycles, campaignId} = {}) {
        const body = {};
        if (phases) body.phases = phases;
        if (cycles) body.cycles = cycles;
        if (campaignId) body.campaign_id = campaignId;
        const response = await GameMasterApi.gamemasterCyclesAdvanceCreate(body);
        return response.data;
    }
}

export default GameMasterCycleService;
